var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":"","outlined":""}},[_c('MyMap',{attrs:{"content":_vm.content,"setActiveWhenLoaded":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }